module.exports = __webpack_public_path__ + "media/images/icons/download-icon-c63a0cccd8056fa8092152e5d5403e3c.svg";